/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react'
import { Button } from 'react-bootstrap'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { BowtieAlarmsRouteContext } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarms/BowtieAlarmsWrapper'
import { CustomList, FilteredSearch } from 'plugin-codaf-risk-ext-bowtie/generic'
import { listAlarmGroupsToList } from 'plugin-codaf-risk-ext-bowtie/services/alarms'
import { IAlarmGroup } from 'plugin-codaf-risk-ext-bowtie/types/alarms'

import { GroupsListContainer } from './styles'

interface IProps {
    alarmGroupToDelete: number
    setAlarmGroupToDelete: (k: number) => void
    setInLoading: (k: boolean) => void
    setAlarmGroupNameToDelete: (k: string) => void
    alarmGroupNameToDelete: string
}

export const GroupsList: React.FC<IProps> = ({
    setAlarmGroupNameToDelete,
    setAlarmGroupToDelete,
    setInLoading,
    alarmGroupToDelete
}) => {
    const [alarmGroups, setAlarmGroups] = useState<IAlarmGroup[]>()
    const { setParams, params } = useContext(BowtieAlarmsRouteContext)

    async function getAllAlarmsGroups(): Promise<void> {
        try {
            setInLoading(true)
            const resquest = await listAlarmGroupsToList(params)

            setAlarmGroups(resquest.data)
        } catch (err) {
            console.error(err)
            globalNotification.error(err.message ?? i18n('An error occurred on list alarm groups.'))
        } finally {
            setInLoading(false)
        }
    }

    const handleSearch = async (keyword?: string): Promise<void> => {
        setParams({ ...params, keyword })
    }

    const handleSortList = async (orderBy: string, direction: 'ASC' | 'DESC'): Promise<void> => {
        setParams({ ...params, orderBy, direction })
    }

    useEffect(() => {
        if (alarmGroupToDelete == null) {
            getAllAlarmsGroups()
        }
    }, [alarmGroupToDelete, params])

    return (
        <>
            <GroupsListContainer>
                <div className="groups-list-search">
                    <Button
                        className="no-outline-button"
                        bsStyle="primary"
                        onClick={() => setParams({ type: 'edit', new: true })}
                        id="alarmGroup-list-button-newAlarmGroup"
                        style={{ marginRight: 12 }}
                    >
                        <i className="far fa-plus custom-plus" /> {i18n('New Group')}
                    </Button>

                    <FilteredSearch
                        inputId="alarmGroup-list-field-alarmGroupSearch"
                        keyword={params.keyword}
                        selectedFilterOption={params.filterBy}
                        onSearch={handleSearch}
                    />
                </div>
                {alarmGroups && alarmGroups.length > 0 ? (
                    <CustomList
                        label={i18n('Alarm groups')}
                        list={alarmGroups.map(group => ({
                            groupName: group.groupName,
                            groupDescription: group.groupDescription,
                            users: group.alarmUsers.length,
                            liveGroupAuthor: group.liveGroupAuthor,
                            id: group.id,
                            alarmBowties: group.alarmBowties,
                            alarmUsers: group.alarmUsers
                        }))}
                        columns={[
                            { title: i18n('GROUP'), listRef: 'groupName', sortable: true },
                            { title: i18n('DESCRIPTION'), listRef: 'groupDescription', sortable: true },
                            { title: i18n('USERS'), listRef: 'users', sortable: true },
                            { title: i18n('RESPONSIBLE'), listRef: 'liveGroupAuthor', sortable: true }
                        ]}
                        sortField={params.orderBy === 'GROUPNAME' ? 'GROUPNAME' : params.orderBy}
                        onSortClick={handleSortList}
                        sortDirection={params.direction}
                        tableProps={{ style: { width: '100%' } }}
                        configOptions={[
                            {
                                icon: 'far fa-edit',
                                onClickConfig: k => setParams({ id: k.id, type: 'edit' })
                            },
                            {
                                icon: 'far fa-trash-alt',
                                onClickConfig: k => {
                                    setAlarmGroupToDelete(k.id)
                                    setAlarmGroupNameToDelete(k.groupName)
                                }
                            }
                        ]}
                        pagination={{
                            type: 'live',
                            totalItems: alarmGroups.length,
                            showingItems: alarmGroups.length
                        }}
                    />
                ) : (
                    <div className="no-group">
                        <i className="far fa-folder-open" />
                        <p>{i18n('There are no groups yet')}</p>
                        <a onClick={() => setParams({ type: 'edit', new: true })}>{i18n('Create a new group')}</a>
                    </div>
                )}
            </GroupsListContainer>
        </>
    )
}
